// Style
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  loader: { margin: 10 },
  wrapper: { width: '100%', height: 420, padding: 10 },
}));

export default useStyles;
